export default angular.module('constants', []);
